import axiosClient from './axiosClient';

const groupApi = {
  getAll: (params) => {
    const url = '/groups';
    return axiosClient.get(url, {
      params,
    });
  },
  create: (data) => {
    const url = '/groups';
    return axiosClient.post(url, data);
  },
  edit: (id, data) => {
    const url = `/groups/${id}`;
    return axiosClient.put(url, data);
  },
  delete: (id) => {
    const url = `/groups/${id}`;
    return axiosClient.delete(url);
  },
  getById: (id) => {
    const url = `/groups/${id}`;
    return axiosClient.get(url);
  },
  getGroupByCourse: (id) => {
    const url = `/groups/get-groups-by-course/${id}`;
    return axiosClient.get(url);
  },
  getIntakeByGroups: (id, param) => {
    const url =
      `/groups/get-lessons-and-groups-by-course/${id}?` +
      new URLSearchParams(param);
    return axiosClient.get(url);
  },
  //details page //  delete group
  deletegroup: (id) => {
    const url = `/groups/${id}`;
    return axiosClient.delete(url);
  },

  // update group
  updategroup: (id, data) => {
    const url = `/groups/${id}`;
    return axiosClient.put(url, data);
  },

  //  delete Unit
  deleteunit: (id) => {
    const url = `/course-units/${id}`;
    return axiosClient.delete(url);
  },

  // update Unit
  updateunit: (id, data) => {
    const url = `/course-units/${id}`;
    return axiosClient.put(url, data);
  },

  // content clone
  groupClone: (id, data) => {
    const url = `/groups/clone-group?id=${id}`;
    return axiosClient.post(url, data);
  },

  unitClone: (id, data) => {
    const url = `/course-units/clone-unit?id=${id}`;
    return axiosClient.post(url, data);
  },

  sectionClone: (id, data) => {
    const url = `/units/clone-section?id=${id}`;
    return axiosClient.post(url, data);
  },

  SubsectionClone: (id, data) => {
    const url = `/units/clone-sub-section?id=${id}`;
    return axiosClient.post(url, data);
  },
  reOrder: (id, body) => {
    const url = `/groups/reorder-by-course/${id}`;
    return axiosClient.put(url, body);
  },

  //new Detail page content
  getDefaultList: (param) => {
    const url =
      `/user-courses/get-default-course-units?` + new URLSearchParams(param);
    return axiosClient.get(url);
  },

  getGroupList: (id, param) => {
    const url =
      `/groups/get-groups-by-intake/${id}?` + new URLSearchParams(param);
    return axiosClient.get(url);
  },

  getGroupAllData: (id, param) => {
    const url =
      `/groups/get-units-and-lessons-by-group/${id}?` +
      new URLSearchParams(param);
    return axiosClient.get(url);
  },

  getGroupContent: (id, param) => {
    const url =
      `/course-units/get-units-by-group/${id}?` + new URLSearchParams(param);
    return axiosClient.get(url);
  },

  getUnitContent: (id, param) => {
    const url =
      `/course-units/get-course-unit-lessons/${id}?` +
      new URLSearchParams(param);
    return axiosClient.get(url);
  },

  getSectionContent: (id, param) => {
    const url =
      `/course-units/get-section-lessons/${id}?` + new URLSearchParams(param);
    return axiosClient.get(url);
  },
  getUnitList: (id, params) => {
    const url = `/course-units/get-lessons-by-unit/${id}`;
    return axiosClient.get(url, { params });
  },

  getUnitSection: (id, params) => {
    const url = `/course-units/get-sections-by-unit/${id}`;
    return axiosClient.get(url, { params });
  },

  getSectionList: (id, params) => {
    const url = `/course-units/get-lessons-by-section/${id}`;
    return axiosClient.get(url, { params });
  },

  getSectionBySub: (id, params) => {
    const url = `/course-units/get-sub-sections-by-section/${id}`;
    return axiosClient.get(url, { params });
  },

  getSubSectionList: (id, params) => {
    const url = `/course-units/get-lessons-by-sub-section/${id}`;
    return axiosClient.get(url, { params });
  },

  unitManualMarking: (data) => {
    const url = `/user-courses/manual-unit-question-marking`;
    return axiosClient.post(url, data);
  },

  unitAssigmentReview: (data) => {
    const url = `/user-courses/assignment-review`;
    return axiosClient.post(url, data);
  },
};

export default groupApi;
